export const PATHS = {
  main: '/',
  signUp: '/sign-up',
  signIn: '/sign-in',
  user: '/user/:userID',
  organization: '/organization/:organizationID',
  addSubscription: '/organization/:organizationID/add-subscription',
  addPackage: '/organization/:organizationID/add-package',
  addDiagnocoins: '/organization/:organizationID/add-diagnocoins',
  productEditor: '/editor',
};
